<template>
  <tabs parent="models_list">
    <tab id="articles" :name="translate('device_models.articles')" :href="url+'articles'" >
      <Articles />
    </tab>

    <tab id="models" :name="translate('device_models.models')" :href="url+'models'" >
      <Models />
    </tab>
  </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Models from './Tabs/Models/Index.vue'
import Articles from './Tabs/Articles/Index.vue'

export default {
  name: 'ModelsList',
  components:{
    Tab,
    Tabs,
    Models,
    Articles
  },
  computed: {
    url () { return '/models_list/' }
  },

}
</script>
